import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

/**
 * Поиск автомобиля по идентификационному номеру (VIN).
 */
export default class extends Controller {
  static get targets() {
    return ['input', 'trucks'];
  }

  initialize() {
    this.timeout = null;
    this.renderedArticle = null;
  }

  connect() {
    this.inputTarget.addEventListener('change', () =>
      this.searchTrucks()
    );
    this.inputTarget.addEventListener('keydown', () =>
      this.searchTrucks()
    );
    this.inputTarget.addEventListener('paste', () =>
      this.searchTrucks()
    );

    if (this.inputTarget.value.length > 7) {
      this.searchTrucks()
    }
  }

  disconnect() {
    this.inputTarget.removeEventListener('change', () =>
      this.searchTrucks()
    );
    this.inputTarget.removeEventListener('keydown', () =>
      this.searchTrucks()
    );
    this.inputTarget.removeEventListener('paste', () =>
      this.searchTrucks()
    );
  }

  renderLoader() {
    this.trucksTarget.innerHTML = `<br><div class="loader is-pulled-left"></div>&nbsp;Ищем автомобиль в нашей базе...`;
  }

  renderNotFound(vin) {
    this.trucksTarget.innerHTML = `<br><p class="content is-paddingless">Автомобиль с идентификационным номером (VIN) «${vin}» не найден в нашей базе.</p>`;
  }

  renderTruck(truck) {
    return `
      <div class="control">
        <label class="radio">
          <input type="radio" name="catalog_request[truck_id]" value="${truck.id}">
          ${truck.production_vin} / ${truck.assembly_vin} ${truck.model_alt}
        </label>
      </div>
    `;
  }

  renderTrucks(trucks) {
    let result = [];
    const simpleTrucks = [];
    for (const truck of trucks) {
      simpleTrucks.push(this.renderTruck(truck));
    }

    if (simpleTrucks.length > 0) {
      result = [...result, ...simpleTrucks];
    }

    this.trucksTarget.innerHTML = result.join('');
  }

  searchTrucks() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const vin = this.inputTarget.value;
      if (vin.length > 7 && vin !== this.renderedVin) {
        this.renderLoader();

        const that = this;
        Rails.ajax({
          type: 'GET',
          url: `/categories/search_trucks.json?q=${vin}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderTrucks(data);
            } else {
              that.renderNotFound(vin);
            }

            that.renderedVin = vin;
          },
          error: () => {
            alert('Ошибка при попытке найти автомобиль по вашему запросу');
          },
        });
      }
    }, 400);
  }
}
